export default __webpack_public_path__ + "static/media/custom-millwork.7cb68d74.jpg";